Service = App.loadClass 'core::Angular/Service'

class exports.MachineryService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    planters: (crop_id = null) =>
        return @http.post 'backend/grower/layers/planting-rx/ng-planters', { crop_id }
